<ion-content class="org-structure-encapsulation-none container">

  <div class="containt-box">
    <div class="phi-flex-wrap-center-space-between phi-gap-12">
      <div class="OrgStructure">Organizational Structure</div>
      <div class="phi-flex-wrap-center phi-gap-12">
        <button type="button" *ngIf="showOnlyVacant" class="orgStructureSecondBtn fs-14 fs_12ForMobile"
          (click)="toggleVacantFilter()">
          <span class="material-icons fs-14 fs_12ForMobile">arrow_back_ios</span>
        </button>

        <div class="phi-flex org-struct-colors-container phi-align-items-center"
          *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
          <div class="phi-flex org-struct-colors">
            <label class="rounded-color-picker" [style.background-color]="orgStructColors.orgStructNameColor"></label>
            <label class="rounded-color-picker" [style.background-color]="orgStructColors.orgStructBgColor"></label>
            <label class="rounded-color-picker" [style.background-color]="orgStructColors.orgStructBorderColor"></label>
          </div>
          <label class="plusIcon cp" (click)="onOpenColorPallet()">+</label>
        </div>

        <div class="phi-flex-wrap-center phi-gap-12">
          <div
            *ngIf="!showOnlyVacant && loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <button type="button" class="orgStructureBtn" [style.background-color]="buttonColorName"
              (click)="onClickOpenManpowerPlanVsActualPopup()">Manpower Plan vs Actual</button>
          </div>

          <div class="download-pdf">
            <button type="button" class="orgStructureSecondBtn fs-14 fs_12ForMobile phi-flex-center phi-gap-8"
              [matMenuTriggerFor]="menu" [style.border-color]="buttonColorName" [style.color]="buttonColorName"
              (click)="toggleDownloadBtnFn()">
              <span class="material-icons fs-20">download</span>
              <span *ngIf="!mobileResponsiveService.hideForMobile"> Download </span>
              <span *ngIf="!toggleDownloadBtn" class="material-icons fs-20">keyboard_arrow_down</span>
              <span *ngIf="toggleDownloadBtn" class="material-icons fs-20">keyboard_arrow_up</span>
            </button>
            <mat-menu class="mr-30 mt-10 w-100" #menu="matMenu" (closed)="toggleDownloadBtnFn()">
              <div class="pl-15 center-content">
                <ion-row>
                  <ion-col size="12">
                    <div (click)="exportTableToPDF('orgChartPdf')" class="fs-14 fs_12ForMobile pt-10 cp">PDF</div>
                    <div (click)="exportToPng('orgChartPdf', 'org-chart')" class="fs-14 fs_12ForMobile pt-15 cp">PNG
                    </div>
                  </ion-col>
                </ion-row>
              </div>
            </mat-menu>
          </div>
        </div>

      </div>
    </div>

    <ion-row class="mt-30 mb-20 phi-align-items-center">
      <ion-col size="12" size-md class="mb-10">
        <div class="phi-flex-wrap-center phi-gap-12">
          <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
            <mat-select placeholder="FY Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)">
              <mat-option [value]="item.year"
                *ngFor="let item of companyYears">{{sharedService.transformYearToFyFormat(item?.year)}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="w-100 mw-sm-125 mat-height40 mat-input-style">
            <mat-select placeholder="Select Month" [(ngModel)]="selectedMonth"
              (selectionChange)="onMonthChange($event)">
              <mat-option *ngFor="let month of getYearMonth" [value]="month">{{month}}</mat-option>
            </mat-select>
          </mat-form-field>

          <ng-select [addTag]="true"
            placeholder="Select Company Name"  [(ngModel)]="companyName"  (change)="onChangecompany($event)">
            <ng-option [value]="item.id" *ngFor="let item of getListOfCompanyNameOfComp">
              {{ item.name }}
            </ng-option>
          </ng-select>
          <ng-select class="w-100 mw-sm-200 mat-height40 mat-input-style" placeholder="Select Department"
            [(ngModel)]="selectDepartment" (change)="onChangeDepartment($event)">
            <ng-option *ngFor="let dept of getDepartmentData" [value]="dept">{{dept}}</ng-option>
          </ng-select>


          <div class="verticle-center orgChartEmpCountInfo" (click)="toggleVacantFilter()">
            <span><img src="././assets/icon/Vacant.svg" alt="" style="width: 20px; height: 20px;"></span>
            <span class="fs-12 fs_11ForMobile ml-5">Vacant ({{vacantCount}})</span>
          </div>
        </div>
      </ion-col>

      <ion-col size="12" size-md="auto" class="mb-10">
        <div class="orgChartEmpCount phi-flex-center phi-gap-12">
          <!-- <div class="verticle-center orgChartEmpCountInfo" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <span><img src="././assets/icon/LowPotential.svg" alt="" style="width: 20px; height: 20px;"></span>
            <span class="fs-12 fs_11ForMobile ml-5">Low Potential (0)</span>
          </div>
          <div class="verticle-center orgChartEmpCountInfo" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <span><img src="././assets/icon/LowPerformer.svg" alt="" style="width: 20px; height: 20px;"></span>
            <span class="fs-12 fs_11ForMobile ml-5">Low Performer (0)</span>
          </div>
          <div class="verticle-center orgChartEmpCountInfo" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <span><img src="././assets/icon/HighPerforme.svg" alt="" style="width: 20px; height: 20px;"></span>
            <span class="fs-12 fs_11ForMobile ml-5">High Performer (0)</span>
          </div>
          <div class="verticle-center orgChartEmpCountInfo" *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
            <span><img src="././assets/icon/HighPotential.svg" alt="" style="width: 20px; height: 20px;"></span>
            <span class="fs-12 fs_11ForMobile ml-5">High Potential (0)</span>
          </div> --
          <div class="verticle-center orgChartEmpCountInfo" (click)="toggleVacantFilter()">
            <span><img src="././assets/icon/Vacant.svg" alt="" style="width: 20px; height: 20px;"></span>
            <span class="fs-12 fs_11ForMobile ml-5">Vacant ({{vacantCount}})</span>
          </div>-->
        </div>
      </ion-col>
    </ion-row>

    <div [ngClass]="currentChartClass" id="orgChartPdf">
      <div [innerHTML]="addTitleAndFiltersInfo" class="text-center"></div>
      <div class="org-chart-container" [ngStyle]="{'transform': 'scale(' + zoomLevel + ')'}">
        <ul *ngIf="organizationData">
          <li app-org-subordinates *ngFor="let emp of organizationData"
            [ngClass]="{'no-line': emp?.department !== selectDepartment && selectDepartment}" [employee]="emp"
            [selectDepartment]="selectDepartment" [showOnlyVacant]="showOnlyVacant">
          </li>
        </ul>
      </div>
    </div>

    <div class="zoom-controls">
      <button (click)="zoomIn()" class="zoom-button">+</button>
      <span class="zoom-level">{{zoomLevel * 100 | number: '1.0-0'}}%</span>
      <button (click)="zoomOut()" class="zoom-button">-</button>
    </div>
  </div>

</ion-content>